import { createMiddleware } from 'redux-beacon';

import branchEventsMap from '@perpay-web/fintech/beacon/eventMaps/Branch';
import BranchTargetFactory from '@perpay-web/fintech/beacon/targets/Branch';

export function getBranchMiddleware() {
    return createMiddleware(branchEventsMap, BranchTargetFactory());
}
